<template>
    <div class="authCode">
         <div class="prompt">验证码已发送至<span>{{phone}}</span></div>
          <van-form validate-first>
   <van-field
    v-model="params.value1"
    name="pattern"
    type="number"
    placeholder="请输入4位验证码"
    clearable
    autofocus="true"
    @input.native="onInputs"
    maxlength="4"
  />
  <van-button class="toObtain" :disabled="code" @click.native="toObtain" type="default">{{innerText}}</van-button>
  <!-- <div class="toObtain" @click.native="toObtain"></div> -->
  <div class="nextStep">
    <van-button :disabled="params.rules" round block type="info" native-type="submit" @click.native="onSubmit">
      下一步
    </van-button>
  </div>
</van-form>
    </div>
</template>
<script>
import Storage from "@/tools/storage";
export default {
  name: "authCode",
  props: ["phone"],
  data() {
    return {
      params: {
        value1: "",
        rules: true
      },
      innerText: "获取验证码",
      code: false
    };
  },
  methods: {
    onInputs() {
      if (this.params.value1.length == 4) {
        this.params.rules = false;
      } else {
        this.params.rules = true;
      }
    },
    onSubmit() {
      let params = { code: this.params.value1, phone: this.params.phone };
      this.$emit("nextStep", params);
    },
    toObtain() {
      let timer = null;
      clearInterval(timer); //这句话至关重要
      let time = 60;
      let that = this;
      timer = setInterval(function() {
        if (time <= 0) {
          that.innerText = "";
          that.innerText = "重新获取";
          that.code = false;
          clearInterval(timer);
        } else {
          that.code = true;
          that.innerText = "";
          that.innerText = "剩余时间" + time + "秒";
          time--;
        }
      }, 1000);
      let params = { value1: this.phone };
      this.$emit("getsendSms", params);
    }
  },
  mounted() {
    let timer = null;
    clearInterval(timer); //这句话至关重要
    let time = 60;
    let that = this;
    timer = setInterval(function() {
      if (time <= 0) {
        that.innerText = "";
        that.innerText = "重新获取";
        that.code = false;
        clearInterval(timer);
      } else {
        that.code = true;
        that.innerText = "";
        that.innerText = "剩余时间" + time + "秒";
        time--;
      }
    }, 1000);
  }
};
</script>
<style lang="scss" scoped>
.authCode {
  width: 90%;
  margin: 0 auto;
}
</style>

